<mat-card>
  <mat-toolbar>{{title}}
    <span class="fill-remaining-space"></span>
    <button mat-icon-button matTooltip="{{ 'oportunitats.filtre' | translate }}" attr.aria-label="{{ 'oportunitats.filtre' | translate }}" matTooltipClass="tooltip-style" (click)="toggleFiltersVisibility()" style="float: right; margin-left:10px;margin-right: 0">
      <mat-icon color="primary" style="font-size:24px">filter_list</mat-icon>
    </button>
  </mat-toolbar>
  <mat-card-content>
    <mcrit-gestio-seguiment-tecnic-filtres
      *ngIf="showFilters"
      [validFilters]="validFilters"
      (changeFilter)="computeActiveFilters($event)"
      >
    </mcrit-gestio-seguiment-tecnic-filtres>
    <table style="padding-top:40px">
      <thead>
        <tr>
          <th style="width:10px">&nbsp;</th>
          <th (click)="cycleOrdering('clau')" style="width:100px">{{ 'propostaMi.camps.codi' | translate }}
            <mat-icon style="vertical-align: middle">
              {{(
                 orderingParameters['clau'] === 1 ?'keyboard_arrow_up' :(orderingParameters['clau'] === 2 ?
                  'keyboard_arrow_down' : '')
              )}}
            </mat-icon>
          </th>
          <th style="width:120px;text-align: right" (click)="cycleOrdering('data_factura')">{{ 'seguimentTecnic.colData' | translate }}
            <mat-icon style="vertical-align: middle">
              {{(
                orderingParameters['data'] === 1?'keyboard_arrow_up':(orderingParameters['data'] === 2?'keyboard_arrow_down':'')
              )}}
            </mat-icon>
          </th>
          <th style="width:120px;text-align: right" (click)="cycleOrdering('tipus')">{{ 'propostaMi.camps.tipus' | translate }}
            <mat-icon style="vertical-align: middle">
              {{(
                 orderingParameters['tipus'] === 1 ?'keyboard_arrow_up' :(orderingParameters['tipus'] === 2 ?'keyboard_arrow_down' : '')
              )}}
            </mat-icon>
          </th>
          <th style="width:120px;text-align: right" (click)="cycleOrdering('tecnic')">{{ 'projectsList.camps.tecnic' | translate }}
            <mat-icon style="vertical-align: middle">
              {{(
                 orderingParameters['tecnic'] === 1 ?'keyboard_arrow_up' :(orderingParameters['tecnic'] === 2 ?'keyboard_arrow_down' : '')
              )}}
            </mat-icon>
          </th>
        </tr>
      </thead>
      <tbody *ngIf="elementList">
          <tr *ngFor="let seguiment of elementList.rows; let j = index" (click)="this.goProject(seguiment.projecte_codi)"  style="cursor:pointer">
            <td style="width:10px">
              <span *ngIf="pendentRealitzar(seguiment.data_acord, seguiment.data_realitzacio,0)" style="width:15px;float:left"><mat-icon style="color:red;font-size:14px" title="{{ 'seguimentTecnicList.noTascaRealitzada' | translate }}">warning</mat-icon></span>
              <span *ngIf="pendentRealitzar(seguiment.data_acord, seguiment.data_realitzacio,1)" style="width:15px;float:left"><mat-icon style="color:green;font-size:14px" title="{{ 'seguimentTecnicList.tascaRealitzada' | translate }}">warning</mat-icon></span>
              <span *ngIf="pendentRealitzar(seguiment.data_acord, seguiment.data_denegacio,2)" style="width:15px;float:left"><mat-icon style="color:grey;font-size:14px" title="{{ 'seguimentTecnicList.tascaPendent' | translate }}">warning</mat-icon></span>
            </td>
            <td>
              <span *ngIf="seguiment.ambit_proposta=='Europa'" style='color:#0000FF'>{{seguiment.clau}}</span>
              <span *ngIf="seguiment.ambit_proposta=='Internacional'" style='color:#008800'>{{seguiment.clau}}</span>
              <span *ngIf="seguiment.ambit_proposta=='Espanya'" style='color:#800000'>{{seguiment.clau}}</span>
              <span *ngIf="seguiment.ambit_proposta=='Catalunya'" style='color:rgb(100,100,100)'>{{seguiment.clau}}</span>
            </td>
            <td style="text-align: right">
              {{seguiment.data | date}}
            </td>
            <td style="text-align: right">
              {{seguiment.tipus}}
            </td>
            <td style="text-align: right">
              {{seguiment.name}}
            </td>
          </tr>
        </tbody>
    </table>
  </mat-card-content>
  <mat-toolbar class="footer">
    <span class="fill-remaining-space"></span>
    <span style="padding-right: 1em">
      {{ 'facturesRebList.liniesPag' | translate }}: {{listService.rowsPerPage}}
      <button mat-icon-button [mat-menu-trigger-for]="menuNumberRows">
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
    </span>
    <span style="padding-right: 1em" *ngIf="elementList">
      {{ 'facturesRebList.resumRegistres' | translate:{ first: firstRegisterShown, last: lastRegisterShown, total: elementList.registers } }}
    </span>
    <button mat-icon-button (click)="gotoPage(0)">
      <mat-icon>first_page</mat-icon>
    </button>
    <button mat-icon-button (click)="requestPrevious()">
      <mat-icon>keyboard_arrow_left</mat-icon>
    </button>
    <button mat-icon-button (click)="requestNext()">
      <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
  </mat-toolbar>
</mat-card>
<mat-menu #menuNumberRows y-position="above">
    <button mat-menu-item *ngFor="let value of rowsPerPageOptions" (click)="setRowPerPage(value)">{{value}}</button>
</mat-menu>
